<script>
  export let value = ''
  export let placeholder = ''
  export let error = false
  export let height = 92
</script>

<style>
  .kb-field {
    margin-bottom: 8px;
  }

  .kb-form-error {
    width: 100%;
    margin: -3px 0 5px 1px;
    color: #dc3545;
    font-size: 14px;
  }

  .field-wrapper {
    width: 100%;
  }

  .field-wrapper__textarea {
    max-width: 100%;
    min-width: 100%;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px 15px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: 'Open Sans', sans-serif;
    text-rendering: optimizeLegibility;
    min-height: 34px;
    overflow-y: auto;
    color: #000;
  }

  .field-wrapper__textarea::placeholder {
    color: #747272;
  }
</style>

<div class="$style.kb-field">
  <div class="$style.field-wrapper">
    <textarea
      class="$style.field-wrapper__textarea"
      bind:value
      {placeholder}
      style="height: {height}px;" />
  </div>
</div>
{#if error !== false}
  <div class="$style.kb-form-error">{error}</div>
{/if}
